<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      highlight-current-row
      :tree-config="treeConfig"
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      @current-change="onCurrentChange"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:bizSysDictStatus="{ row }">
        <el-tag
          size="mini"
          :type="row.bizSysDictStatus === 'Y' ? 'light' : 'warning'"
        >
          {{ row.bizSysDictStatusName }}
        </el-tag>
      </template>
      <template v-slot:empty>
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">暂无数据！</p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import store from '../../store'
export default {
  mixins: [TableAutoHeight],
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    tablePage: {
      type: Object,
      default: () => {},
    },
    loading: {
      default: false,
    },
  },
  components: {},
  data() {
    return {
      treeConfig: {},
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
      },
      tableColumns: [
        {
          field: 'seq',
          width: 50,
          align: 'center',
          fixed: 'left',
          type: 'seq',
        },
        {
          title: '大类名称',
          field: 'bizSysDictName',
          align: 'center',

          minWidth: '120px',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
        },
        {
          title: '状态',
          width: '60px',
          align: 'center',
          slots: { default: 'bizSysDictStatus' },
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
        },
        {
          title: '大类编码',
          field: 'bizSysDictType',
          minWidth: '120px',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
        },
      ],
    }
  },
  methods: {
    onCurrentChange({ row }) {
      store.commit('setSelected', row)
    },
    del(code) {
      this.$confirm('确认要删除该记录吗？', '确认信息', {
        type: 'warning',
      }).then(() => {
        this.$api.sysDictDelApi(code).then((res) => {
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'success',
          })
          this.$emit('reload')
        })
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}
</style>
